import React from 'react';
import { Sparkles, Heart, Award } from 'lucide-react';
import { businessInfo } from '../data/mockData';
import SEO from '../components/SEO';

const About = () => {
  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="Rreth Nesh"
        description="Njihuni me Lor95 Boutique në Berat, një destinacion për modë moderne për femra dhe meshkuj, këpucë, aksesorë dhe stile të përzgjedhura."
        path="/about"
      />

      {/* Seksioni Kryesor */}
      <section className="relative h-96 flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0 z-0">
          <img 
            src={businessInfo.clothingRacksImage}
            alt="Brendësia e Lor95 Boutique"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black/40"></div>
        </div>
        
        <div className="relative z-10 text-center px-4">
          <h1 className="text-5xl sm:text-6xl font-serif font-bold text-white mb-4 animate-in fade-in slide-in-from-bottom duration-700">
            Rreth Lor95 Boutique
          </h1>

          <p className="text-xl text-white/90 animate-in fade-in slide-in-from-bottom duration-700 delay-150">
            Ku Eleganca Takohet me Modën Moderne
          </p>
        </div>
      </section>


      {/* Seksioni Historia Jonë */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">

          <div className="space-y-8 text-center">

            <h2 className="text-4xl font-serif font-bold text-gray-900">
              Historia Jonë
            </h2>

            <div className="space-y-6 text-lg text-gray-700 leading-relaxed">

              <p>
                I vendosur në qytetin historik të Beratit, Shqipëri, Lor95 Boutique lindi nga
                pasioni për t'u ofruar femrave dhe meshkujve mundësinë për të zbuluar stilin e
                tyre unik dhe për të shprehur personalitetin e tyre përmes modës.
                Që nga krijimi ynë, jemi përkushtuar në përzgjedhjen e një koleksioni modern,
                elegant dhe cilësor, i cili i përshtatet njerëzve që vlerësojnë stilin,
                cilësinë dhe elegancën.
              </p>

              <p>
                Butiku ynë është më shumë se thjesht një vend për të blerë veshje – është një
                destinacion ku moda takohet me shërbimin e personalizuar. Ne përzgjedhim me
                kujdes çdo produkt të koleksionit tonë, duke u siguruar që ai të përmbushë
                standardet tona të larta të cilësisë, stilit dhe përpunimit.
                Nga veshjet elegante të mbrëmjes deri te modelet moderne dhe casual për
                përditshmëri, çdo artikull përzgjidhet për t'ju ofruar një kombinim të
                përsosur mes stilit, cilësisë dhe komoditetit.
              </p>

              <p>
                Në Lor95 Boutique, ne besojmë se moda është një mënyrë për të shprehur
                personalitetin dhe individualitetin. Pavarësisht nëse kërkoni një veshje
                elegante, një kombinim modern për përditshmëri apo diçka të veçantë për një
                rast të rëndësishëm, ekipi ynë është i gatshëm t'ju ndihmojë të gjeni stilin
                që ju përshtatet më së miri.
              </p>

            </div>
          </div>
        </div>
      </section>


      {/* Seksioni i Vlerave */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

          <div className="text-center mb-16">

            <h2 className="text-4xl font-serif font-bold text-gray-900 mb-4">
              Vlerat Tona
            </h2>

            <p className="text-lg text-gray-600">
              Vlerat që udhëheqin gjithçka që bëjmë
            </p>

          </div>


          <div className="grid grid-cols-1 md:grid-cols-3 gap-12">

            {/* Cilësia */}
            <div className="text-center space-y-4 group animate-in fade-in slide-in-from-bottom duration-500">

              <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-white shadow-lg group-hover:shadow-xl transition-all duration-300 group-hover:scale-110">
                <Sparkles className="h-10 w-10 text-gray-900" />
              </div>

              <h3 className="text-2xl font-semibold text-gray-900">
                Cilësia
              </h3>

              <p className="text-gray-600 leading-relaxed">
                Çdo produkt në koleksionin tonë përzgjidhet me kujdes për cilësinë e tij,
                përpunimin, materialet dhe stilin e përjetshëm. Ne besojmë se veshjet cilësore
                janë një investim në stil dhe komoditet.
              </p>

            </div>


            {/* Shërbimi i Personalizuar */}
            <div className="text-center space-y-4 group animate-in fade-in slide-in-from-bottom duration-500 delay-150">

              <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-white shadow-lg group-hover:shadow-xl transition-all duration-300 group-hover:scale-110">
                <Heart className="h-10 w-10 text-gray-900" />
              </div>

              <h3 className="text-2xl font-semibold text-gray-900">
                Shërbim i Personalizuar
              </h3>

              <p className="text-gray-600 leading-relaxed">
                Ekipi ynë i kushton vëmendje çdo klienti, duke u përpjekur të kuptojë stilin,
                preferencat dhe nevojat individuale. Ne ofrojmë këshillim dhe rekomandime
                të personalizuara për t'ju ndihmuar të gjeni zgjedhjen e duhur.
              </p>

            </div>


            {/* Përsosmëria në Stil */}
            <div className="text-center space-y-4 group animate-in fade-in slide-in-from-bottom duration-500 delay-300">

              <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-white shadow-lg group-hover:shadow-xl transition-all duration-300 group-hover:scale-110">
                <Award className="h-10 w-10 text-gray-900" />
              </div>

              <h3 className="text-2xl font-semibold text-gray-900">
                Përsosmëria në Stil
              </h3>

              <p className="text-gray-600 leading-relaxed">
                Ne ndjekim tendencat më të fundit të modës, duke ruajtur njëkohësisht një
                stil elegant dhe të veçantë. Koleksionet tona janë përzgjedhur për t'u
                mundësuar femrave dhe meshkujve të shprehin individualitetin e tyre.
              </p>

            </div>

          </div>
        </div>
      </section>


      {/* Deklarata e Misionit */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">

          <div className="bg-gray-50 p-12 border-l-4 border-gray-900">

            <h2 className="text-3xl font-serif font-bold text-gray-900 mb-6">
              Misioni Ynë
            </h2>

            <p className="text-xl text-gray-700 leading-relaxed italic">
              "Të frymëzojmë çdo klient përmes modës duke ofruar veshje elegante, moderne
              dhe cilësore për femra dhe meshkuj. Në Lor95 Boutique, jemi të përkushtuar
              të ofrojmë një përvojë të veçantë blerjeje, ku cilësia, eleganca, stili dhe
              shërbimi i personalizuar bashkohen për t'i ndihmuar klientët tanë të ndihen
              bukur, rehat dhe me vetëbesim."
            </p>

          </div>
        </div>
      </section>


      {/* Seksioni i Imazheve të Butikut */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">

            {/* Butiku */}
            <div className="relative aspect-[4/5] overflow-hidden shadow-2xl group animate-in fade-in slide-in-from-left duration-700">

              <img 
                src={businessInfo.storefrontImage}
                alt="Fasada e Lor95 Boutique"
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
              />

              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>

              <div className="absolute bottom-8 left-8 right-8 text-white">

                <h3 className="text-2xl font-semibold mb-2">
                  Butiku Ynë
                </h3>

                <p className="text-white/90">
                  I vendosur në zemër të Beratit
                </p>

              </div>
            </div>


            {/* Koleksionet */}
            <div className="relative aspect-[4/5] overflow-hidden shadow-2xl group animate-in fade-in slide-in-from-right duration-700">

              <img 
                src={businessInfo.clothingRacksImage}
                alt="Koleksioni i Modës"
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
              />

              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>

              <div className="absolute bottom-8 left-8 right-8 text-white">

                <h3 className="text-2xl font-semibold mb-2">
                  Koleksione të Përzgjedhura
                </h3>

                <p className="text-white/90">
                  Modele të përzgjedhura me kujdes për femra dhe meshkuj
                </p>

              </div>
            </div>

          </div>
        </div>
      </section>


      {/* Seksioni i Ftesës */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">

          <h2 className="text-4xl font-serif font-bold text-gray-900 mb-6">
            Na Vizitoni Sot
          </h2>

          <p className="text-xl text-gray-600 mb-8">
            Përjetoni stilin dhe cilësinë e Lor95 Boutique.
            Ekipi ynë është gati t'ju ndihmojë të zbuloni veshjen dhe stilin perfekt për ju.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">

            {/* Butoni për Vendndodhjen */}
            <a 
              href="/visit"
              className="inline-flex items-center justify-center px-8 py-4 bg-gray-900 text-white font-semibold hover:bg-gray-800 transition-colors duration-300"
            >
              Gjeni Vendndodhjen
            </a>

            {/* Butoni për Koleksionet */}
            <a 
              href="/collections"
              className="inline-flex items-center justify-center px-8 py-4 border-2 border-gray-900 text-gray-900 font-semibold hover:bg-gray-900 hover:text-white transition-colors duration-300"
            >
              Shiko Koleksionet
            </a>

          </div>
        </div>
      </section>

    </div>
  );
};

export default About;
